import { createSlice } from '@reduxjs/toolkit';
import { deleteBlogsAction, getBlogsAction, postBlogsAction, putBlogsAction } from './blogs.action';

const initialState: Blogs.BlogsState = {
  isLoading: false,
  error: null,
  listBlogs: {
    items: [],
    limit: 10,
    page: 1,
    totalCount: 0,
    totalPage: 0,
  },
};

const { actions, reducer } = createSlice({
  name: 'blogs_slice',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getBlogsAction.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getBlogsAction.fulfilled, (state, action) => {
        state.isLoading = false;
        state.listBlogs = {
          items: action.payload.records,
          limit: action.payload.pageSize,
          page: action.payload.page,
          totalCount: action.payload.totalRecords,
          totalPage: action.payload.totalPage,
        };
      })
      .addCase(getBlogsAction.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(postBlogsAction.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(postBlogsAction.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(postBlogsAction.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error;
      })
      .addCase(putBlogsAction.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(putBlogsAction.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(putBlogsAction.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error;
      })
      .addCase(deleteBlogsAction.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(deleteBlogsAction.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(deleteBlogsAction.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error;
      });
  },
});

export { reducer };
export default actions;
